export const SINGLE_CARD_TEST_ID = {
  singleGridLink: 'single-grid-link',
};
